import DoubleSeatsModal from './components/DoubleSeatsModal.css';
export default {
    DoubleSeatsModal
};
